import { Button, Card, H1, H3, H4, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import EventsCard from "./EventsCard";
import { Footer } from "./Footer";

export const SiteUnderConstructionCard = () => {
  // Existing states
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Existing images loading
    const image = new Image();
    image.src = "/work-deadline-4.svg";
    image.onload = () => setImageLoaded(true);
  }, []);

  // Return null or loading spinner if images are not loaded
  if (!imageLoaded) {
    return null; // or return a loading spinner or any placeholder content
  }

  return (
      <div className="site-container">
        <div className="container">
          <img
              src="/work-deadline-4.svg"
              alt="Work Deadline"
              className="deadline-image" // Use className for styling
          />
          <H1 className="card-header">РАСПИСАНИЕ МАСТЕР-КЛАССОВ</H1>
          <div className="row">
            <Card className="card-inside-container" elevation={4}>
              <Tag className="location-tag" large>ОТРАДА</Tag>
              <Tag className="location-product-tag" large intent={"warning"}>TODES YO LIFE</Tag>
              <H3>DANCEHALL ВЕЧЕРИНКА</H3>
              <H4>07 апреля 2024</H4>
              <p className="event-description">
                Это уникальная возможность окунуться в cолнечный и жизнерадостный вайб, который основан на рэгги-ритме и ямайской культуре. Dancehall включает в себя множество различных танцевальных стилей, из которых фигурным звеном являются основные базовые степы. Динамичный танец свободы, самоутверждения и уверенности в себе даст вам возможность больше раскрыться и чувствовать себя раскованно, как на вечеринке!
              </p>
              <Button
                  icon="shopping-cart"
                  text="Оформить билет"
                  intent="success"
                  large
                  onClick={() =>
                      (window.location.href =
                          "https://masterclass.todes.ru/event/3HTUQL")
                  }
              />
            </Card>
            <Card className="card-inside-container" elevation={4}>
              <Tag className="location-tag" large>ЧЕЛЯБИНСК</Tag>
              <Tag className="location-product-tag" large intent={"warning"}>СОЛИСТЫ ТЕАТРА ТОДЕС</Tag>
              <H3>ПАВЕЛ ВОЛОСОВ</H3>
              <H4>07 апреля 2024</H4>
              <p className="event-description">
                Два эксклюзивных мастер-класса от солиста Театра TODES и репетитора театрального состава - Павла Волосова! Проживите моменты творческого взаимодействия с профессионалом своего дела. Обогатите свой танцевальный опыт, научитесь исполнять поставленную хореографию и доводить своих зрителей до мурашек.
              </p>
              <Button
                  icon="shopping-cart"
                  text="Оформить билет"
                  intent="success"
                  large
                  onClick={() =>
                      (window.location.href =
                          "https://masterclass.todes.ru/event/2IKUUM")
                  }
              />
            </Card>
          </div>
        </div>
        {/*<EventsCard/>*/}
        <Footer/>
      </div>
  );
};
